import React from "react";

const TemplateModal = ({ url }) => {
  return (
    <div className="a4-tile template-a4">
      <iframe className="a4-iframe template-a4-iframe" src={url} sandbox="allow-same-origin" />
    </div>
  );
};

export default TemplateModal;
